"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "argelato": {
    "a7f54878": [{
      "hkey": "3a41c5c2",
      "slug": "volta-reno",
      "name": "Volta Reno",
      "primary": true,
      "skipSearch": false
    }],
    "san-donnino": [{
      "hkey": "3a41c5c2",
      "slug": "volta-reno",
      "name": "Volta Reno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "argelato"
    }]
  }
};
exports["default"] = _default;